export function formatDuration(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds <= 0) return "0m"
  const totalMinutes = Math.floor(seconds / 60)
  const h = Math.floor(totalMinutes / 60)
  const m = totalMinutes % 60
  if (h > 0) return `${h}h ${m}m`
  if (totalMinutes > 0) return `${totalMinutes}m`
  return `${Math.floor(seconds % 60)}s`
}

export function formatHours(seconds: number): string {
  return `${(seconds / 3600).toFixed(1)}h`
}

export function formatTime(iso: string | null): string {
  if (!iso) return "—"
  return new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
}

export function windowSeconds(first: string | null, last: string | null): number {
  if (!first || !last) return 0
  const diff = (new Date(last).getTime() - new Date(first).getTime()) / 1000
  return diff > 0 ? Math.round(diff) : 0
}

export function formatRelative(iso: string | null, neverLabel: string): string {
  if (!iso) return neverLabel
  const diff = Math.max(0, Date.now() - new Date(iso).getTime())
  const s = Math.floor(diff / 1000)
  if (s < 10) return "<10s"
  if (s < 60) return `${s}s`
  const m = Math.floor(s / 60)
  if (m < 60) return `${m}m`
  const h = Math.floor(m / 60)
  if (h < 24) return `${h}h ${m % 60}m`
  return `${Math.floor(h / 24)}d`
}

export function shortDate(date: string): string {
  return date.length >= 10 ? date.slice(5) : date
}
